import { filterProps } from '../utils';
import { ReactIntlError } from '../error';
import { FormatError } from 'intl-messageformat';
var PLURAL_FORMAT_OPTIONS = ['localeMatcher', 'type'];
export function formatPlural(_ref, getPluralRules, value) {
  var locale = _ref.locale,
      onError = _ref.onError;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (!Intl.PluralRules) {
    onError(new FormatError("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", "MISSING_INTL_API"
    /* MISSING_INTL_API */
    ));
  }

  var filteredOptions = filterProps(options, PLURAL_FORMAT_OPTIONS);

  try {
    return getPluralRules(locale, filteredOptions).select(value);
  } catch (e) {
    onError(new ReactIntlError("FORMAT_ERROR"
    /* FORMAT_ERROR */
    , 'Error formatting plural.', e));
  }

  return 'other';
}